<template>
  <div>
    <b-container>
      <b-row>
        <b-col md="8" offset-md="4" class="pb-3">
          <b-container class="form-start bg-light-grey">
            <b-row>
              <b-col md="12" class="text-left">
                <span>Käyttötarkoitus: </span><br/>
                <el-select v-model="userSelection.kayttotarkoitus" placeholder="Valitse" @change="selectKt">
                  <el-option
                          v-for="item in kayttotarkoitukset"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id">
                  </el-option>
                </el-select>
                <div class="mt-3">
                  <b-form-checkbox v-model="userSelection.autosuojaosana" value="Kyllä" unchecked-value="Ei" switch @input="applyFilter" v-if="showARO">
                    Autosuoja rakennuksen osana
                  </b-form-checkbox>
                  <b-form-checkbox v-model="userSelection.myymalaosana" value="Kyllä" unchecked-value="Ei" switch @input="applyFilter" v-if="showMRO">
                    Myymälä rakennuksen osana
                  </b-form-checkbox>
                  <b-form-checkbox class="mb-3" v-model="userSelection.irtainvarastoja" value="Kyllä" unchecked-value="Ei" switch @input="applyFilter" v-if="showIPA">
                    Irtainvarastoja sisältävä palo-osasto asuinkerrostalossa
                  </b-form-checkbox>
                </div>
              </b-col>
              </b-row>
              <b-row class="mt-3">
              <b-col md="6">
                <span>Kerrosmäärä: </span><br/>
                <el-select v-model="userSelection.kerrosmaara" placeholder="Valitse" @change="selectKerros">
                  <el-option label="1-kerroksinen" :value="1"></el-option>
                  <el-option label="2-kerroksinen" :value="2"></el-option>
                  <el-option label="3-kerroksinen" :value="3"></el-option>
                  <el-option label="4-kerroksinen" :value="4"></el-option>
                  <el-option label="5-kerroksinen" :value="5"></el-option>
                  <el-option label="6-kerroksinen" :value="6"></el-option>
                  <el-option label="7-kerroksinen" :value="7"></el-option>
                  <el-option label="8-kerroksinen" :value="8"></el-option>
                  <el-option label="Yli 8-kerroksinen" :value="9"></el-option>
                </el-select>
              </b-col>
              <b-col md="6">
                <span>Sprinklaus: </span><br/>
                <b-form-checkbox v-model="userSelection.sprinklaus" value="Kyllä" unchecked-value="Ei" :disabled="sprinklausCanBeSet" switch @input="applyFilter">
                  <b>{{ sprinklausLabel }}</b>
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col md="6">
                <span>Korkeus:</span><br/>
                <el-input placeholder="Korkeus" size="small" v-model="userSelection.korkeus" @input="applyFilter">
                  <template slot="append">m</template>
                </el-input>
              </b-col>
              <b-col md="6">
                <span>Kerrosala:</span><br/>
                <el-input placeholder="Kerrosala" size="small" v-model="userSelection.kerrosala" @input="applyFilter">
                  <template slot="append">m<sup>2</sup></template>
                </el-input>
              </b-col>
              <b-col md="6" class="mt-3">
                <template v-if="userSelection.kayttotarkoitus === 9 || userSelection.kayttotarkoitus === 10">
                  <span>Paikkaluku:</span><br/>
                  <el-input placeholder="Paikkaluku" size="small" v-model="userSelection.henkilomaara" @input="applyFilter">
                    <template slot="append">kpl</template>
                  </el-input>
                </template>
                <template v-else>
                  <span>Henkilömäärä:</span><br/>
                  <el-input placeholder="Henkilömäärä" size="small" v-model="userSelection.henkilomaara" @input="applyFilter">
                    <template slot="append">hlö</template>
                  </el-input>
                </template>
              </b-col>
              <b-col md="6" class="mt-3">
                <span>Palo-osaston koko kerroksissa:</span><br/>
                <el-input placeholder="Palo-osaston koko" size="small" v-model="userSelection.tilat" @input="applyFilter" v-if="!(userSelection.kayttotarkoitus == 5 || userSelection.kayttotarkoitus == 6 || userSelection.kayttotarkoitus == 7)">
                  <template slot="append">m<sup>2</sup></template>
                </el-input>
                <span v-else><b>Osastointi huoneistoittain</b></span>
                <div class="mt-2 danger" v-if="showEhdotG"><span class="text-danger">Katso ehdot G sivun alareunasta</span></div>
              </b-col>
            </b-row>
            <b-row class="mt-3" v-if="userSelection.kayttotarkoitus === 9 || userSelection.kayttotarkoitus === 10">
              <b-col md="6">
                <span>Palo-osaston koko kerroksissa (yöpymistilat): </span><br/>
                <el-input placeholder="Palo-osaston koko" size="small" v-model="userSelection.yopymistilat" @input="applyFilter" v-if="!(userSelection.kayttotarkoitus == 5 || userSelection.kayttotarkoitus == 6 || userSelection.kayttotarkoitus == 7)">
                  <template slot="append">m<sup>2</sup></template>
                </el-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="py-5">
                <router-link to="/jarjestelmat" v-if="userSelection.results.p1 || userSelection.results.p2 || userSelection.results.p3" class="button-orange">
                  <font-awesome-icon icon="arrow-circle-right" class="icon"></font-awesome-icon> Siirry seuraavaan
                </router-link>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="bg-white" fluid>
      <b-row>
      <b-col>
      <b-container class="pt-2 pb-5">
      <div v-if="userSelection.results.p1 !== null || userSelection.results.p2 !== null || userSelection.results.p3 !== null" class="p-results">
        <b-row class="pt-5">
          <b-col md="12"><h1>Mahdolliset paloluokat</h1></b-col>
        </b-row>
        <b-row class="p-3 top-radius">
          <b-col class="text-left"><b>Paloluokka</b></b-col>
          <b-col><b>Runko</b></b-col>
          <b-col><b>Mitoitus</b></b-col>
          <b-col><b>Kerrosmäärä</b></b-col>
          <b-col><b>Korkeus</b></b-col>
          <b-col><b>Kerrosala</b></b-col>
          <b-col><b>Henkilöm.</b></b-col>
          <b-col><b>Palo-osasto</b></b-col>
        </b-row>

        <b-row class="p-3 row-p3" v-for="(result, name, index) in userSelection.results" :class="result !== null && result.passed?'passed':'failed'" :key="index">
          <template v-if="result !== null">
            <b-col class="text-left p-label"><font-awesome-icon icon="check"></font-awesome-icon> {{name}}</b-col>
            <template v-if="result.error !== ''">
              <b-col class="col-sm-10">{{result.error}}</b-col>
            </template>
            <template v-if="result.error === ''">
              <b-col>{{result.runko}}</b-col>
              <b-col v-html="result.mitoitus"></b-col>
              <b-col><font-awesome-icon :icon="result.kerrosmäärä?'check-circle':'times-circle'"></font-awesome-icon></b-col>
              <b-col><font-awesome-icon :icon="result.korkeus?'check-circle':'times-circle'"></font-awesome-icon></b-col>
              <b-col><font-awesome-icon :icon="result.kerrosala?'check-circle':'times-circle'"></font-awesome-icon></b-col>
              <b-col><font-awesome-icon :icon="result.henkilomäärä?'check-circle':'times-circle'"></font-awesome-icon></b-col>
              <b-col><font-awesome-icon :icon="result.paloosasto?'check-circle':'times-circle'"></font-awesome-icon></b-col>
            </template>
          </template>
        </b-row>
      </div>
      </b-container>
      </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import kayttotarkoitukset from '../data/kayttotarkoitukset.js'
import checkRequirements from '../data/vaatimukset.js'

export default {
  name: 'Paloluokka',
  data () {
    return {
      kayttotarkoitukset: kayttotarkoitukset
    }
  },
  computed: {
    sprinklausLabel () {
      if (this.userSelection.kerrosmaara > 2) {
        if (this.userSelection.kayttotarkoitus !== 5 && this.userSelection.kayttotarkoitus !== 6) {
          return 'Pakollinen'
        }
      }
      return this.userSelection.sprinklaus
    },
    sprinklausCanBeSet () {
      if (this.userSelection.kerrosmaara > 2) {
        if (this.userSelection.kayttotarkoitus !== 5 && this.userSelection.kayttotarkoitus !== 6) {
          return true
        }
      }
      if ((this.userSelection.kayttotarkoitus === 5 || this.userSelection.kayttotarkoitus === 6) && this.userSelection.kerrosmaara < 3) {
        return true
      }
      return false
    },
    showARO () {
      return true
    },
    showMRO () {
      if (this.userSelection.kayttotarkoitus === 3 || this.userSelection.kayttotarkoitus === 5 || this.userSelection.kayttotarkoitus === 6) {
        return false
      }
      return true
    },
    showIPA () {
      if (this.userSelection.kayttotarkoitus === 7) {
        return true
      }
      return false
    },
    showEhdotG () {
      if (this.userSelection.kayttotarkoitus === 3 && (this.userSelection.kerrosmaara > 2 || this.userSelection.korkeus > 9)) {
        return true
      }
      return false
    }
  },
  methods: {
    selectKt (option) {
      this.userSelection.kt = kayttotarkoitukset[option].group
      this.userSelection.ktid = option
      if (option === 5) {
        this.userSelection.sprinklaus = 'Ei'
      } else if (this.userSelection.kerrosmaara > 2) {
        this.userSelection.sprinklaus = 'Kyllä'
      }
      this.applyFilter()
    },
    selectKerros (option) {
      if (option > 2 && (this.userSelection.kayttotarkoitus !== 5 && this.userSelection.kayttotarkoitus !== 6)) {
        this.userSelection.sprinklaus = 'Kyllä'
      }
      this.applyFilter()
    },
    applyFilter () {
      var candidate = {
        kt: this.userSelection.kt,
        ktid: this.userSelection.ktid,
        kerrosmäärä: this.userSelection.kerrosmaara,
        sprinklaus: this.userSelection.sprinklaus,
        kerrosala: this.userSelection.kerrosala,
        tilat: this.userSelection.tilat,
        henkilomäärä: this.userSelection.henkilomaara,
        yöpymistilat: this.userSelection.yopymistilat,
        korkeus: this.validateNumber(this.userSelection.korkeus),
        mitoitus: 'Taulukko'
      }

      if (this.userSelection.kayttotarkoitus === 5 || this.userSelection.kayttotarkoitus === 6 || this.userSelection.kayttotarkoitus === 7) {
        candidate.tilat = 0
      }

      if (!this.showMRO) {
        this.userSelection.myymalaosana = 'Ei'
      }

      if (!this.showIPA) {
        this.userSelection.irtainvarastoja = 'Ei'
      }

      this.userSelection.results.p1 = null
      this.userSelection.results.p2 = null
      this.userSelection.results.p3 = null

      // check if values set
      var doCheck = false
      if (candidate.kt != null && candidate.kerrosmäärä > 0 && candidate.korkeus > 0 && candidate.henkilomäärä > 0 && candidate.tilat > 0) {
        doCheck = true
      }
      if ((candidate.kt === 3 || candidate.kt === 4) && candidate.kerrosmäärä > 0 && candidate.korkeus > 0 && candidate.henkilomäärä > 0) {
        doCheck = true
      }
      if (candidate.kt === 6 || candidate.kt === 7) {
        doCheck = candidate.kerrosmäärä > 0 && candidate.korkeus > 0 && candidate.henkilomäärä > 0 && candidate.tilat > 0 && candidate.yöpymistilat > 0
      }

      if (doCheck) {
        // console.debug(candidate.kt)
        this.userSelection.results.p1 = checkRequirements(candidate, 'P1')
        this.userSelection.results.p2 = checkRequirements(candidate, 'P2')
        this.userSelection.results.p3 = checkRequirements(candidate, 'P3')
        this.$emit('changed')
      }
    },
    validateNumber (num) {
      var s = num + ''
      s = s.replace(',', '.')
      return Number(s)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-select{
    width: 75%;
  }

  input{
    max-width: 120px;
  }
  .el-input--small{
    max-width: 215px;
  }
  .fa-check-circle,
  .fa-check{
    color: green;
  }
  .fa-times-circle{
    color: red;
  }

  .top-radius{
    border-radius: 4px 4px 0 0;
  }
  .bottom-radius{
    border-radius: 0 0 4px 4px;
  }

  .p-results .row{
    border-right: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;

  }
  .p-results .row:nth-child(even){
    background-color: #FAFAFA;
  }
  .p-results .row:nth-child(2){
    border-top: 1px solid #dee2e6;
  }
  .p-results .row:first-child{
    border-right: none;
    border-left: none;
  }
  .p-results .row:last-child{
    border-bottom: 1px solid #dee2e6;
    border-radius: 0 0 4px 4px;
  }
  .p-label{
    text-transform: uppercase;
  }

  .passed .p-label{
    font-weight: bold;
  }

  .failed .col{
    color: #ababab;
  }
  .failed .fa-check-circle{
    color: #ababab;
  }
  .failed .fa-check{
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Paloluokka.vue